import { render } from "./ReminderSchedulePanel.vue?vue&type=template&id=25b4e47e&scoped=true"
import script from "./ReminderSchedulePanel.vue?vue&type=script&lang=js"
export * from "./ReminderSchedulePanel.vue?vue&type=script&lang=js"

import "./ReminderSchedulePanel.vue?vue&type=style&index=0&id=25b4e47e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b4e47e"]])

export default __exports__